import get from 'lodash/get';
import error from 'aurora-utils/error';
import * as types from './constants';

const defaultState = {
  loading: false,
  unitsLoading: false,
  error,
  initiateApplicationResponse: {},
  application: {},
  // company: {},
  documents: [],
  // individual:{}
  secondPartyType: '',
  validation: {},
  unitValidation: [],
  properties: {},
  savedUnits: {},
  breakdown: {},
  activeStep: 0,
  PMAType: 'PMC',
};

export default function pmaReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.PMA_APPLICATION_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.PMA_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.PMA_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action?.payload?.error,
      };
    case types.INITIAL_PAGE_LOAD:
      return {
        ...state,
        error: null,
      };
    case types.INITIATE_PMA_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.PMC_SIGNATORY_APPROVAL:
    case types.BANK_APPROVAL:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.INITIATE_PMA_APPLICATION_SUCCESS:
      return {
        ...state,
        initiateApplicationResponse: action.payload,
        loading: false,
      };
    case types.UPDATE_PMA_TYPE:
      return {
        ...state,
        PMAType: action.payload,
      };
    case types.INITIATE_PMA_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.PMC_SIGNATORY_APPROVAL_ERROR:
    case types.BANK_APPROVAL_ERROR:
      return { ...state, loading: false, error: action.payload };
    case types.FETCH_PMA_APPLICATION:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_PMA_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: action.payload,
        PMAType: action.payload.pmaType,
        secondPartyType: action.payload?.company && action.payload?.company.tradeLicenseNo ? 'COMPANY' : 'INDIVIDUAL',
        // company: {
        //   ...action?.payload?.company,
        //   tradeLicenseNo: action?.payload?.company?.tradeLicenseNo,
        //   nameEn: action?.payload?.company?.nameEn,
        //   nameAr: action?.payload?.company?.nameAr,
        //   phone: action?.payload?.company?.phone,
        //   email: action?.payload?.company?.email,
        // },
      };
    case types.FETCH_PMA_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.FETCH_PMA_COMPANY_DETAILS:
      return {
        ...state,
        loading: true,
        application: {
          ...state.application,
          company: null,
        },
      };
    case types.FETCH_PMA_COMPANY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        application: {
          ...state.application,
          company: {
            ...action?.payload?.company,
            tradeLicenseNo: action?.payload?.tradeLicenseNumber,
            nameEn: action?.payload?.companyNameEn,
            nameAr: action?.payload?.companyNameAr,
            phone: action?.payload?.mobileNumber,
            email: action?.payload?.companyEmail,
          },
          individual: null,
        },
      };
    case types.FETCH_PMA_COMPANY_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.SAVE_PMA_APPLICATION:
      return {
        ...state,
        loading: true,
      };
    case types.SAVE_PMA_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.SAVE_PMA_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.CHANGE_PMA_STEP:
      return {
        ...state,
        activeStep: action.payload,
      };
    case types.PMA_FIELD_CHANGE:
      if (action.payload.object) {
        return {
          ...state,
          application: {
            ...state.application,
            [action.payload.object]: {
              ...state.application[action.payload.object],
              // [action.payload.name]: action.payload.value,
              ...action.payload.valueObject,
            },
          },
        };
      }
      return {
        ...state,
        application: {
          ...state.application,
          ...action.payload.valueObject,
        },
      };
    case types.UPLOAD_PMA_DOCUMENT:
      return {
        ...state,
        loading: true,
      };
    case types.UPLOAD_PMA_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        documents: [...state.documents, action.payload],
      };
    case types.UPLOAD_PMA_DOCUMENT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.DOWNLOAD_PMA_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_PMA_DOCUMENT_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.DOWNLOAD_PMA_DOCUMENT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.DELETE_PMA_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DELETE_PMA_DOCUMENT_SUCCESS: {
      const newDocs = state.documents.filter(file => file.id !== action.payload?.fileId);
      return {
        ...state,
        loading: false,
        error: null,
        documents: newDocs,
      };
    }
    case types.DELETE_PMA_DOCUMENT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.GET_PMA_DOCUMENTS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.GET_PMA_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        documents: action.payload,
      };
    }
    case types.GET_PMA_DOCUMENTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.FETCH_PMA_USER_DETAILS:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_PMA_USER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        application: {
          ...state.application,
          individual: {
            eidNumberOrUnified: action.payload?.eid || action.payload?.unified,
            nameEn: action.payload?.nameEn,
            nameAr: action.payload?.nameAr,
            email: action.payload?.email,
            phone: action.payload?.phoneNumber,
            nationalityEn: action.payload?.nationalityEn,
            nationalityAr: action.payload?.nationalityAr,
            birthDate: action.payload?.birthDate,
            passportIssueDate: action.payload?.passportIssueDate,
            passportExpiryDate: action.payload?.passportExpiryDate,
          },
          company: null,
        },
      };
    case types.FETCH_PMA_USER_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case 'secondPartyType':
      return {
        ...state,
        loading: false,
        secondPartyType: action.payload,
      };
    case types.ADD_PMA_PROPERTIES:
      return {
        ...state,
        loading: true,
      };
    case types.ADD_PMA_VALIDATION_ERROR:
      return {
        ...state,
        loading: false,
        validation: action.payload,
      };
    case types.ADD_PMA_UNIT_VALIDATION_ERROR:
      return {
        ...state,
        loading: false,
        unitValidation: [...state.unitValidation, action.payload],
      };
    case types.ADD_PMA_PROPERTIES_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.ADD_PMA_PROPERTIES_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.GET_PMA_BUILDINGS:
      return {
        ...state,
        loading: true,
      };
    case types.GET_PMA_BUILDINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        properties: action.payload,
      };
    case types.GET_PMA_BUILDINGS_ERROR:
      return {
        ...state,
        loading: false,
      };
    case types.GET_PMA_UNITS:
      return {
        ...state,
        unitsLoading: true,
      };
    case types.GET_PMA_UNITS_SUCCESS:
      return {
        ...state,
        unitsLoading: false,
        savedUnits: action.payload,
      };
    case types.GET_PMA_UNITS_ERROR:
      return {
        ...state,
        unitsLoading: false,
      };

    case types.CHECKOUT_PMA_APPLICATION:
      return {
        ...state,
        loading: true,
      };
    case types.CHECKOUT_PMA_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        savedUnits: action.payload,
      };
    case types.CHECKOUT_PMA_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.DOWNLOAD_PMA_CONTRACT_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_PMA_CONTRACT_DOCUMENT_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.DOWNLOAD_PMA_CONTRACT_DOCUMENT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.GET_PMA_CANCEL_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.GET_PMA_CANCEL_APPLICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.GET_PMA_CANCEL_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.CLEAR_PMA_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        unitValidation: [],
      };
    case types.PMA_FORM_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case types.GET_PMA_UNITS_BY_BUILDING:
      return {
        ...state,
        loading: true,
      };
    case types.GET_PMA_UNITS_BY_BUILDING_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.GET_PMA_UNITS_BY_BUILDING_ERROR:
      return {
        ...state,
        loading: false,
      };
    case types.FETCH_BREAKDOWN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_BREAKDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        breakdown: get(action.payload, 'breakdown'),
        error: null,
      };
    case types.FETCH_BREAKDOWN_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error'),
      };
    case types.REJECT_WITH_REASON:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.REJECT_WITH_REASON_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.REJECT_WITH_REASON_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.RESET_ERROR:
      return {
        ...state,
        error: null,
        loading: false,
        unitValidation: [],
      };
    default:
      return state;
  }
}
